import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import Avatar from "react-avatar";
import moment from "moment";
import jwt_decode from "jwt-decode";
import { useDispatch } from "react-redux";
import { deleteComment } from "../../redux/actions/tasks";
import RepliesSection from "../CommentReplies";
import EditCommentModal from "./EditComment";
import ConfirmationBox from "../ConfirmationBox";
import { withCookies, useCookies } from "react-cookie";

const SingleComment = ({
  onAddReply,
  comment,
  tasklist_id,
  task_id,
  color,
  showActions,
  handleUpdateComment,
  handleDeleteComment,
  showEdit,
  showDelete,
  taskType,
}) => {
  const dispatch = useDispatch();
  const [translation] = useTranslation("translations");
  const [showReplies, setShowReplies] = useState(false);
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [loading, setLoading] = useState(false);
  const [cookies] = useCookies(["sustainyou_user_jwt"]);

  const handleShowConfirmation = () => setShowConfirmation(true);
  const handleCloseConfirmation = () => setShowConfirmation(false);

  const handleToggleReplies = () => {
    if (!showReplies) {
      setShowEditComment(false);
    }
    setShowReplies((prev) => !prev);
  };
  const handleHideReplies = () => {
    setShowReplies(false);
  };
  const [showEditComment, setShowEditComment] = useState(false);

  const handleToggleEditComment = () => {
    if (!showEditComment) {
      setShowReplies(false);
    }
    setShowEditComment((prev) => !prev);
  };
  const handleHideEditModal = () => {
    setShowEditComment(false);
  };

  const handleDelete = async () => {
    try {
      setLoading(true);
      let commentObj = {
        comment_id: comment?.comment_id,
      };
      await dispatch(
        deleteComment({
          comment: commentObj,
          taskId: task_id,
          listId: tasklist_id,
          parent: comment?.comment_parent,
          taskType: taskType,
        })
      );
      handleDeleteComment(comment);
      handleCloseConfirmation();
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };
  return (
    <div className={`d-flex flex-column border-${color} rounded `}>
      {!showEditComment && (
        <>
          <div className="d-flex mt-2 justify-content-between mt-1">
            <div>
              <Avatar
                name={comment.comment_author}
                round="50px"
                size="25"
                className={`bg-${color}`}
              />
              <span
                /* comment by name */
                className={` text-capitalize ms-2`}
                style={{ fontWeight: "bold" }}
              >
                {comment.comment_author}
              </span>
            </div>
            {
              <div>
                <small
                  className="ms-3 grey-color"
                  title={moment(comment.comment_date).format(
                    "DD MMM YYYY , h:mm:ss a"
                  )}
                >
                  {moment(comment.comment_date).fromNow()}
                </small>
              </div>
            }
          </div>
          <div
            className="px-4 ms-2 para-design grey-color mb-3"
            dangerouslySetInnerHTML={{
              __html: comment.comment_content,
            }}
          ></div>
        </>
      )}
      <>
        {!showEditComment && (
          <div className="px-4 ms-2">
            {showActions && (
                <span
                  // respond comment  in cemment seciton | color removed
                  className={`cursor-pointer me-3 grey-color fw-bold`}
                  onClick={() => {
                    handleToggleReplies();
                  }}
                >
                  {translation("task_forms.comments.actions.reply")}
                </span>
              )}
            {showEdit &&
              parseInt(jwt_decode(cookies.sustainyou_user_jwt).id) ===
                parseInt(comment.comment_author_id) && (
                <span
                  // edit comment  in cemment seciton | color removed
                  className={`cursor-pointer me-3 grey-color fw-bold`}
                  onClick={() => {
                    handleToggleEditComment();
                  }}
                >
                  {translation("task_forms.comments.actions.edit")}
                </span>
              )}
            {showDelete &&
              parseInt(jwt_decode(cookies.sustainyou_user_jwt).id) ===
                parseInt(comment.comment_author_id) && (
                <span
                  // delete comment  in cemment seciton | color removed
                  className={`cursor-pointer me-3 grey-color fw-bold`}
                  onClick={() => {
                    handleShowConfirmation();
                  }}
                >
                  {translation("task_forms.comments.actions.delete")}
                </span>
              )}
          </div>
        )}

        {showEditComment && (
          <EditCommentModal
            handleClose={handleHideEditModal}
            show={showEditComment}
            selectedComment={comment}
            color={color}
            task_id={task_id}
            tasklist_id={tasklist_id}
            handleUpdateComment={handleUpdateComment}
          />
        )}

        <ConfirmationBox
          show={showConfirmation}
          handleClose={handleCloseConfirmation}
          title={translation("delete_comment")}
          message={translation("delete_comment_warning")}
          confirmationAction={handleDelete}
          loading={loading}
          size="sm"
        />
      </>
      {showReplies && (
        <RepliesSection
          handleClose={handleHideReplies}
          show={showReplies}
          selectedComment={comment}
          color={color}
          task_id={task_id}
          tasklist_id={tasklist_id}
          onClickSaveHideEditor={handleToggleReplies}
          onAddReply={onAddReply}
        />
      )}
    </div>
  );
};

export default withCookies(SingleComment);
